import React from 'react'
// import PropTypes from 'prop-types'

import { MainTitle, Subtitle, 
  TextContent, HighlightText, 
  JsonCodeStyle, LinkText
} from '../../../Shared';
import { StyledSeparated } from '../UserRegister/UserRegister.styled';

const UserLogin = props => {
  const requestData = {
    "username": "string",
    "password": "string"
  };

  const responseSuccess = {
    "code": 200,
    "message": "success",
    "data": {
        "evaluation_score": 0,
        "evaluation_count": 0,
        "_id": "5dc3e711a6da9a3b2cebc1bb",
        "name": "Khanh Tran",
        "username": "khanhtran",
        "status": "active",
        "phone": "097xxxxxxx",
        "createdAt": "2019-11-07T09:42:41.861Z",
        "updatedAt": "2020-08-02T23:51:52.414Z",
        "__v": 0,
        "avatar": "link here",
        "email": "xxx@gmail.com",
        "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9 xxxx"
    }
  };

  const loginFailed = {
    "code": 400,
    "message": "Username/password is incorrect",
    "errors": []
  };

  return (
    <div>
      <MainTitle>User Login</MainTitle>
      <Subtitle id="request-1-login">1. Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/auth/login</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@POST</TextContent>
      <TextContent><b><i>Request Data</i></b></TextContent>
      <JsonCodeStyle data={requestData} />

      <Subtitle id="response-3-login">2. Response</Subtitle>

      <Subtitle isSmall id="a-success-login">a. Success</Subtitle>
      <JsonCodeStyle data={responseSuccess} />
      <TextContent><HighlightText>access_token</HighlightText>is a string that used to authenticate user.
      <LinkText target="_blank" path="https://jwt.io/">More information about this method</LinkText></TextContent>
    
      <Subtitle isSmall id="b-errors-login">b. Errors</Subtitle>
      <TextContent>&nbsp;&nbsp; Login failed</TextContent>
      <JsonCodeStyle data={loginFailed} />
      <StyledSeparated />
    </div>
  )
}

UserLogin.propTypes = {

}

export default UserLogin
